import React from "react";
import "./confirmationPopup.scss";

interface DialogProps {
  show: boolean;
  title?: string;
  message?: string;
  icon?: string;
  buttonStyle?: "Circular" | "Square";
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryButtonAction?: () => void;
  secondaryButtonAction?: () => void;
}

const Dialog: React.FC<DialogProps> = ({
  show,
  title,
  message,
  icon,
  buttonStyle = "Circular",
  primaryButtonText = "Yes",
  secondaryButtonText = "No",
  primaryButtonAction,
  secondaryButtonAction,
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-inner-content">
        {icon && (
          <div className="modal-icon">
            <img src={icon} alt="Confirm Icon" />
          </div>
        )}

        {title && <div className="modal-title">{title}</div>}
        {message && <div className="modal-message">{message}</div>}

        <div
          className={`modal-buttons ${
            buttonStyle === "Square"
              ? "modal-buttons-square"
              : "modal-buttons-circular"
          }`}
        >
          <button
            onClick={secondaryButtonAction}
            className="button-style no-btn"
            type="button"
          >
            {secondaryButtonText}
          </button>

          <button
            onClick={primaryButtonAction}
            className="button-style yes-btn"
            type="button"
          >
            {primaryButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dialog;